import { createGtm } from '@gtm-support/vue-gtm';

const gtmId = import.meta.env.VITE_GTM_ID as string;
const gtmSource = import.meta.env.VITE_GTM_SOURCE as string;

const gtmPlugin = (() => {
  if (!gtmId) {
    console.warn(
      'VITE_GTM_ID environment variable is not defined. GTM tracking will be disabled.',
    );
    return;
  }

  const gtmParams: {
    id: string;
    enabled: boolean;
    debug: boolean;
    source?: string;
  } = {
    id: gtmId,
    enabled: true,
    debug: import.meta.env.DEV,
  };

  if (gtmSource) {
    const url = new URL('2gbsek14pe3o5jx.js', gtmSource);
    gtmParams.source = url.href;
  } else {
    console.warn(
      'VITE_GTM_SOURCE environment variable is not defined. GTM tracking will use the default script issued by Google.',
    );
  }

  return createGtm(gtmParams);
})();

export default gtmPlugin;
